// import { data } from "isotope-layout";
import PropTypes from "prop-types";
import React from 'react';
// import {Link} from "react-router-dom";
import FileName from '../../data/pic/filename.json';



const WorkDetailsContainer = () => {
    // const cate = data.categories.map((value, i) => {
    //     return(
    //         <span className="d-inline" key={i}>{value}{i !== data.categories.length - 1 && " , "}</span>
    //     )
    // })
    return (
        <div className="section section-padding">
            <div className="container">
                <div className="row pt--100 pb--80">

                    <div className="col-lg-4 col-md-6 col-12">
                        <div className="work-left work-details" data-aos="fade-up">
                            <div className="portfolio-main-info">
                                <h2 className="title">Wonderful Moments </h2>
                                <div className="work-details-list mt-12">

                                    <div className="details-list">
                                        <label>Years</label>
                                        <span>2022</span>
                                    </div>
                                    <div className="details-list">
                                        <label>Date</label>
                                        <span>15th-19th, July</span>
                                    </div>

                                    <div className="details-list">
                                        <label>Location</label>
                                        <span>Xi&apos;an, China (Virtual)</span>
                                    </div>


                                    {/* <div className="details-list">
                                        <label>Awards</label>
                                        <span>{data.awards}</span>
                                    </div> */}

                                </div>
                                {/* <div className="work-share pt--70 pt_md--40 pt_sm--40">
                                    <h6 className="heading heading-h6">SHARE</h6>
                                </div> */}
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-7 col-md-6 offset-lg-1 col-12">
                        <div className="work-left work-details mt-6">
                            <div className="work-main-info">
                                <div className="work-content">
                                    <h4 className="title" data-aos="fade-up">The Thirteenth International Conference on Swarm Intelligence (ICSI&apos;2022)</h4>

                                    <div className="desc mt-8">
                                        <p>
                                    On July 17, The 13th International Conference on Swarm Intelligence (ICSI&apos;2022) was Successfully Concluded. Due to the rapid overspreading of the Omicron variant of COVID-19, the ICSI 2022 organizing committee has made the decision that our ICSI 2022 will continue as scheduled on July 15-19, by being converted to a fully virtual conference. 
                                        </p>

                                        <p>
                                    The theme of ICSI&apos;2022 is &quot;Serving Life with Swarm Intelligence&quot;. The ICSI&apos;2022 provided an excellent opportunity and/or an academic forum for academics and practitioners to present and discuss the latest scientific results and methods, innovative ideas, and advantages in theories, technologies, and applications in swarm intelligence. The technical program covered a number of aspects of swarm intelligence and its related areas.

                                        </p>
                                    
                                        <p>
                                    Our conference attracted numerous scholars from dozens of countries and regions and received 150 submissions and invited submissions from about 380 authors. During the five days, all participants listened to reports and discussed the latest progress in the field of swarm intelligence and its related areas.
                                        </p>


                                    


                                        {/* {data.body.map((value, i) => {
                                            return(
                                                <div key={i} className="content mb-5" data-aos="fade-up" dangerouslySetInnerHTML={{__html: value}} />
                                            )
                                        })} */}
{/* DONE: fix the linkage problem  */}
                                        {/* <div className="work-btn" data-aos="fade-up">
                                            <a className="btn btn-primary btn-hover-secondary" href="www.baidu.com">Baidu</a>
                                        </div> */}

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row mt-lg-20 mt-12">
                    <div className="col-lg-4 col-md-12 col-12">
                        <div className="digital-marketing" data-aos="fade-up">
                            <h3 className="heading heading-h3">Opening Ceremony</h3>
                        </div>
                    </div>
                    <div className="col-lg-7 col-md-12 col-12 offset-lg-1">
                        <div className="digital-marketing mt-lg-0 mt-6" data-aos="fade-up">
                            <div className="inner">
                                <p>The conference officially started at 9:30 am on July 16. The chairman of ICSI&apos;2022, Prof. Tan Ying presided over the opening ceremony of the conference and gave an opening speech. Prof. Tan Ying reported on the meeting and extended a warm welcome to everyone. Although we can not hold a grand meeting offline, our meeting can be very exciting online as well.</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-lg-12">
                        <div className="custom-column-thumbnail mt-lg-14 mt-1" data-aos="fade-up">
                            <img className="w-100" src='./images/gallery/group-1.jpg' alt="Agency" />
                        </div>
                    </div>
                </div>

                <div className="row mt-lg-20 mt-12">
                    <div className="col-lg-4 col-md-12 col-12">
                        <div className="digital-marketing" data-aos="fade-up">
                            <h3 className="heading heading-h3">Plenary Speech</h3>
                        </div>
                    </div>
                    <div className="col-lg-7 col-md-12 col-12 offset-lg-1">
                        <div className="digital-marketing mt-lg-0 mt-6" data-aos="fade-up">
                            <div className="inner">
                                <p>ICSI&apos;2022 was honored to invite Prof. Licheng Jiao to give a plenary speech at the conference. Prof. Jiao showed the development history of evolutionary computing and gave his thoughts on the relevance of evolutionary computing and deep learning. </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="custom-layout-gallery mt-lg-20 mt-12">
                        {/* big one */}
                        <div className="col-lg-12 my-6">
                            <div className="thumbnail" data-aos="fade-up">
                                <img className="w-100" src="./images/gallery/plenery talk 1.jpg" alt="Agency" />
                            </div>
                        </div>
                    <div className="row">
                        <div className="col-lg-6 col-md-6 col-12">
                            <div className="thumbnail" data-aos="fade-up">
                                <img className="w-100" src="./images/gallery/plenery talk 3.jpg" alt="Agency" />
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6 col-12 mt-lg-0 mt-md-0 mt-10">
                            <div className="thumbnail" data-aos="fade-up">
                                <img className="w-100" src="./images/gallery/plenery talk 2.jpg" alt="Agency" />
                            </div>
                        </div>


                    </div>
                </div>


                {/* ---------------------------invited best student paper presentation */}

                <div className="row mt-lg-20 mt-12">
                    <div className="col-lg-4 col-md-12 col-12">
                        <div className="digital-marketing" data-aos="fade-up">
                            <h3 className="heading heading-h3">Invited Best Student Paper Presentation</h3>
                        </div>
                    </div>
                    <div className="col-lg-7 col-md-12 col-12 offset-lg-1">
                        <div className="digital-marketing mt-lg-0 mt-6" data-aos="fade-up">
                            <div className="inner">
                                <p>After a short break, Tingjun Lei, the author of the Best Student Paper, presented his work &quto; A Bio-Inspired Neural Network Approach to Robot Navigation and
Mapping with Nature-Inspired Algorithms &quot; at the conference.

</p>
                            </div>
                        </div>
                    </div>
                </div>
                {/* gallery */}
                <div className="custom-layout-gallery mt-lg-20 mt-12">
                        {/* big one */}
                        <div className="col-lg-12 my-6">
                            <div className="thumbnail" data-aos="fade-up">
                                <img className="w-100" src="./images/gallery/bssp.jpg" alt="Agency" />
                            </div>
                        </div>
                </div>
{/* -------------------------------------------------------------- */}
{/* -----------------------------------inv talk-------------------- */}
                <div className="row mt-lg-20 mt-12">
                    <div className="col-lg-4 col-md-12 col-12">
                        <div className="digital-marketing" data-aos="fade-up">
                            <h3 className="heading heading-h3">Invited Talk</h3>
                        </div>
                    </div>
                    <div className="col-lg-7 col-md-12 col-12 offset-lg-1">
                        <div className="digital-marketing mt-lg-0 mt-6" data-aos="fade-up">
                            <div className="inner">
                                <p>Next, Prof. Okyay Kaynak from  Bogazici University, Turkey gave an Invited Talk entitled &quto;What is AI&quto;. The report explained the history and the current research status of artificial intelligence. Meanwhile, he put forward his own insights on the future development of artificial intelligence.</p>

                                <p>
                                In the afternoon, Prof. Danilo Pelusi from TeramoUniversity, Italy gave an Invited Talk entitled &quto;Adapting swarm intelligent algorithms to specific optimization problems&quto;. In this report, Prof. Danilo Pelusi introduced a new Moth-flame optimization algorithm and introduced how to adaptively control its optimization process. </p>


                            </div>
                        </div>
                    </div>
                </div>
                {/* gallery */}
                <div className="custom-layout-gallery mt-lg-20 mt-12">
                        {/* big one */}
                        <div className="col-lg-12 my-6">
                            <div className="thumbnail" data-aos="fade-up">
                                <img className="w-100" src="./images/gallery/invited talk 1.jpg" alt="Agency" />
                            </div>
                        </div>
                        <div className="col-lg-12 my-6">
                            <div className="thumbnail" data-aos="fade-up">
                                <img className="w-100" src="./images/gallery/invited talk 2.jpg" alt="Agency" />
                            </div>
                        </div>
                    {/* <div className="row">
                        <div className="col-lg-6 col-md-6 col-12">
                            <div className="thumbnail" data-aos="fade-up">
                                <img className="w-100" src="./images/gallery/0246.jpg" alt="Agency" />
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6 col-12 mt-lg-0 mt-md-0 mt-10">
                            <div className="thumbnail" data-aos="fade-up">
                                <img className="w-100" src="./images/gallery/0246.jpg" alt="Agency" />
                            </div>
                        </div>


                    </div> */}
                </div>
{/* -------------------------------------------------------------- */}
{/* parellel sessions */}
{/* -------------------------------------------------------------- */}
                <div className="row mt-lg-20 mt-12">
                    <div className="col-lg-4 col-md-12 col-12">
                        <div className="digital-marketing" data-aos="fade-up">
                            <h3 className="heading heading-h3">Parallel Sessions</h3>
                        </div>
                    </div>
                    <div className="col-lg-7 col-md-12 col-12 offset-lg-1">
                        <div className="digital-marketing mt-lg-0 mt-6" data-aos="fade-up">
                            <div className="inner">
                                <p>All the authors of ICSI&apos;2022 presented their papers at the conference. There are three parallel sessions meeting rooms in total. Participants can choose topics and papers of interest, listen to their reports and communicate with the authors. </p>
                            </div>
                        </div>
                    </div>
                </div>
                {/* gallery */}
                <div className="custom-layout-gallery mt-lg-20 mt-12">
                        {/* big one */}
                        {/* <div className="col-lg-12 my-6">
                            <div className="thumbnail" data-aos="fade-up">
                                <img className="w-100" src="./images/gallery/plenary talk 1.jpg" alt="Agency" />
                            </div>
                        </div> */}
                        {/* small one */}

                    <div className="row">

                        {FileName.map((data, i) => {
                            return(
                                <div className="col-lg-4 col-md-4 col-12" key={i}>
                                                <div className="thumbnail" data-aos="fade-up">
                                                    <img className="w-100" src={"./images/gallery/" +data.file} alt={data.file} />
                                                </div>
                                            </div>
                                            )
                                        })}


                        {/* <div className="col-lg-4 col-md-4 col-12">
                            <div className="thumbnail" data-aos="fade-up">
                                <img className="w-100" src={"./images/gallery/"+ data.file} alt="Agency" />
                            </div>
                        </div>  */}


    
                        {/* <div className="col-lg-4 col-md-4 col-12 mt-lg-0 mt-md-0 mt-10">
                            <div className="thumbnail" data-aos="fade-up">
                                <img className="w-100" src="./images/gallery/0246.jpg" alt="Agency" />
                            </div>
                        </div> */}


                    </div>
                </div>
{/* -------------------------------------------------------------- */}
{/* award ceremony */}
{/* -------------------------------------------------------------- */}
                            <div className="row mt-lg-20 mt-12">
                                <div className="col-lg-4 col-md-12 col-12">
                                    <div className="digital-marketing" data-aos="fade-up">
                                        <h3 className="heading heading-h3">Award Ceremony
</h3>
                                    </div>
                                </div>
                                <div className="col-lg-7 col-md-12 col-12 offset-lg-1">
                                    <div className="digital-marketing mt-lg-0 mt-6" data-aos="fade-up">
                                        <div className="inner">
                                            <p>On the evening of July 17, the conference held an award ceremony. Prof. Ying Tan announced all the awards of this year&apos;s conference and took a group photo with them. </p>
                                            <p>
                                            In addition, Prof. Tan Ying introduced a new track added this year—ICSI-OC. ICSI Optimization Competition (ICSI-OC) is a series of algorithm competitions held by ICSI. ICSI-OC provides dedicated test sets and competitions for researchers to test their swarm intelligence algorithms and evolutionary algorithms. ICSI-OC’2022 received six algorithms and selected the top three based on their performance. Prof. Ying Tan announced the winners and took photos with the competitors.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* gallery */}
                            <div className="custom-layout-gallery mt-lg-20 mt-12">
                                    {/* big one */}
                                    {/* <div className="col-lg-12 my-6">
                                        <div className="thumbnail" data-aos="fade-up">
                                            <img className="w-100" src="./images/gallery/plenary talk 1.jpg" alt="Agency" />
                                        </div>
                                    </div> */}
                                <div className="row">
                                    <div className="col-lg-6 col-md-6 col-12">
                                        <div className="thumbnail" data-aos="fade-up">
                                            <img className="w-100" src="./images/gallery/best-5645.jpg" alt="Agency" />
                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-md-6 col-12 mt-lg-0 mt-md-0 mt-10">
                                        <div className="thumbnail" data-aos="fade-up">
                                            <img className="w-100" src="./images/gallery/best-inv-2.jpg" alt="Agency" />
                                        </div>
                                    </div>
            
            
                                </div>
                                <div className="row">
                                    <div className="col-lg-6 col-md-6 col-12">
                                        <div className="thumbnail" data-aos="fade-up">
                                            <img className="w-100" src="./images/gallery/best-stu-5529.jpg" alt="Agency" />
                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-md-6 col-12 mt-lg-0 mt-md-0 mt-10">
                                        <div className="thumbnail" data-aos="fade-up">
                                            <img className="w-100" src="./images/gallery/best-stu-9704.jpg" alt="Agency" />
                                        </div>
                                    </div>
            
            
                                </div>
                                <div className="row">
                                    <div className="col-lg-6 col-md-6 col-12">
                                        <div className="thumbnail" data-aos="fade-up">
                                            <img className="w-100" src="./images/gallery/best-ss.jpg" alt="Agency" />
                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-md-6 col-12 mt-lg-0 mt-md-0 mt-10">
                                        <div className="thumbnail" data-aos="fade-up">
                                            <img className="w-100" src="./images/gallery/icsi-oc-golden.jpg" alt="Agency" />
                                        </div>
                                    </div>
            
            
                                </div>

                                <div className="row">
                                    <div className="col-lg-6 col-md-6 col-12">
                                        <div className="thumbnail" data-aos="fade-up">
                                            <img className="w-100" src="./images/gallery/icsi-oc-silver.jpg" alt="Agency" />
                                        </div>
                                    </div>
                                    {/* <div className="col-lg-6 col-md-6 col-12 mt-lg-0 mt-md-0 mt-10">
                                        <div className="thumbnail" data-aos="fade-up">
                                            <img className="w-100" src="./images/gallery/icsi-oc-golden.jpg" alt="Agency" />
                                        </div>
                                    </div> */}
            
            
                                </div>


                            </div>
            {/* -------------------------------------------------------------- */}


            </div>
        </div>
    )
}

WorkDetailsContainer.propTypes = {
    data: PropTypes.object
};

export default WorkDetailsContainer;
